import { createContext, useContext } from 'react';

export type ToastStackAdd = (message: string) => void;

export const ToastStackContext = createContext<ToastStackAdd>(() => {
  //initial context
});

export const useToastStack = () => {
  return useContext(ToastStackContext);
};
